<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    On-Farm Store
  </header>

  <div class="d-flex justify-content-center align-items-center mb-5">

    <div class="container">

      <div class="on-farm-store">

        <div class="on-farm-store__info">

          <div>

            <p class="h6-regular">
              In addition to ordering online for our Atlanta deliveries, products can be purchased directly from our
              farm store, located at the base of the silo at the farm in Rockmart, GA.
            </p>

            <p class="h6-regular">
              You’ll find a selection of products we raise here at the farm, including <strong>raw cow’s milk for pets,
                free-range eggs, grass-fed beef, and pork</strong>. We also offer some products from other local farmers
              and producers.
            </p>

            <p class="h6-regular">
              Come by and check out our store, talk to the farmers, and see our animals. <strong>CASH OR CARDS ONLY. WE
                DO NOT ACCEPT CHECKS.</strong>
            </p>

          </div>

          <div class="contact-card">

            <span class="material-symbols-outlined text-primary">
              location_on
            </span>

            <div class="d-flex flex-column g-2">
              <span class="h6-bold">
                Location
              </span>
              <span class="h6-regular">
                Carlton Farms 1276 Cartersville Hwy., Rockmart, GA 30153
              </span>
            </div>

          </div>

          <div class="contact-card">

            <span class="material-symbols-outlined text-primary">
              call
            </span>

            <div class="d-flex flex-column g-2">
              <span class="h6-bold">
                Brad (Tours/Field-trips)
              </span>
              <span class="h6-regular">
                770-546-5179
              </span>
            </div>

          </div>

          <h2 class="h2-semibold">
            Farm Store Hours
          </h2>

          <div class="hours">

            <ul class="m-0">
              <li>
                Monday - Saturday 10 am - 6 pm
              </li>
              <li>
                Sunday - CLOSED
              </li>
              <li>
                (Open on Sunday 10 am - 6 pm during October only)
              </li>
            </ul>

          </div>

          <button class="btn btn-primary mt-2" type="button" [routerLink]="['/shop']">
            VIEW ONLINE STORE
          </button>

        </div>

        <img class="on-farm-store__img" src="/assets/images/landing/farm-activities/on-farm-store/store.webp"
          alt="View of a rustic farm store next to a weathered metal silo, with a sign reading 'Welcome to the Farm' above the entrance">

      </div>

    </div>

  </div>

</section>
